export const UPDATE_CONTINUE_WATCHING_ITEMS = 'CONTINUE_WATCHING';
